<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.5858 4H10V2H17H18V3V10H16V5.41421L8.70711 12.7071L7.29289 11.2929L14.5858 4ZM8 6H4L4 16H14V12H16V16C16 17.1046 15.1046 18 14 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H8V6Z"
  />
</svg>
